<template>
  <div class="w-100">
    <DropZone @drop.prevent="drop" @change="selectedFile" ID="dropzoneFile" :fileInfo="{
      title: this.$t(
        'page.files_upload.click_upload_pictures_videos_documents'
      ),
      accept: this.$t('page.files_upload.type'),
      limit: '50M',
    }" :accept="'.ppt,.pptx,.pdf,.xls,.xlsx,.doc,.docx,.png,.jpeg,.jpg,.mp4,.mov,.glb'" />
    <h4 class="card-title mb-1 mt-3 flex-grow-1" v-show="showfiles['image'].length ||
      showfiles['video'].length ||
      (showfiles['3d'] && showfiles['3d'].length) ||
      showfiles['document'].length
      ">
      {{ this.$t("page.files_upload.uploaded_data") }}
    </h4>
    <div class="border border-solid rounded p-3" v-show="showfiles['image'].length ||
      showfiles['video'].length ||
      (showfiles['3d'] && showfiles['3d'].length) ||
      showfiles['document'].length
      ">
      <div v-show="showfiles['image'].length">
        <div>
          <div class="border-primary fs-14 material-title">
            {{ this.$t("base.picture") }}
          </div>
        </div>
        <div class="product-img-slider sticky-side-div ps-5 pe-5">
          <RelationSwiperTool :swiperInfo="{
      type: 'image',
      page: 'modelform',
      spaceBetween: 10,
      slidesPerView: 15,
      actionsClass: [
        { name: 'ri-eye-line', action: 'view' },
        { name: 'ri-download-2-fill', action: 'download' },
        { name: 'ri-delete-bin-5-fill', action: 'delete' }
      ],
    }" :list="showfiles['image']" @deleteFile="deleteFile">
          </RelationSwiperTool>
        </div>
      </div>
      <div class="mt-4 mb-4" v-show="showfiles['video'].length">
        <div>
          <div class="border-primary fs-14 material-title">
            {{ this.$t("base.video") }}
          </div>
        </div>
        <div class="product-img-slider sticky-side-div ps-5 pe-5">
          <RelationSwiperTool :swiperInfo="{
      type: 'video',
      page: 'modelform',
      spaceBetween: 10,
      slidesPerView: 15,
      actionsClass: [
        { name: 'ri-play-circle-line', action: 'play' },
        { name: 'ri-download-2-fill', action: 'download' },
        { name: 'ri-delete-bin-5-fill', action: 'delete' }
      ],
    }" :list="showfiles['video']" @deleteFile="deleteFile">
          </RelationSwiperTool>
        </div>
      </div>
      <div v-show="showfiles['document'].length">
        <div>
          <div class="border-primary fs-14 material-title">
            {{ this.$t("base.document") }}
          </div>
        </div>
        <div class="product-img-slider sticky-side-div ps-5 pe-5">
          <RelationSwiperTool :swiperInfo="{
      type: 'document',
      page: 'modelform',
      spaceBetween: 10,
      slidesPerView: 15,
      actionsClass: [
        { name: 'ri-eye-fill', action: 'view' },
        { name: 'ri-download-2-fill', action: 'download' },
        { name: 'ri-delete-bin-5-fill', action: 'delete' }
      ],

    }" :list="showfiles['document']" @deleteFile="deleteFile">
          </RelationSwiperTool>
        </div>
      </div>
      <div v-show="showfiles['3d'] && showfiles['3d'].length">
        <div>
          <div class="border-primary fs-14 material-title">{{ $t('模型') }}</div>
        </div>
        <div class="product-img-slider sticky-side-div ps-5 pe-5">
          <RelationSwiperTool :swiperInfo="{
      type: 'document',
      page: 'modelform',
      spaceBetween: 10,
      slidesPerView: 15,
      actionsClass: [
        { name: 'ri-eye-fill', action: 'view' },
        { name: 'ri-download-2-fill', action: 'download' },
        { name: 'ri-delete-bin-5-fill', action: 'delete' }
      ],
    }" :list="showfiles['3d'] && showfiles['3d']" @deleteFile="deleteFile">
          </RelationSwiperTool>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import DropZone from "@/components/widgets/dropZone";
import { v4 as uuidv4 } from "uuid";
import RelationSwiperTool from "@/components/relationSwiperTool.vue";
import axios from "axios";
import { getUploadFileSign, getUploadFileDetail } from "@/service/index";
import { imageCompress } from "@/utils/common.js";

export default {
  emits: ["update:files", "handleAlert"],
  props: {
    files: {
      type: Object,
      default: () => {
        return { image: [], video: [], document: [] };
      },
    },
  },
  setup() { },
  data() {
    return {
      showfiles: { image: [], video: [], document: [], '3d': [] },
      fileMaxSize: 1024 * 1024 * 50,
    };
  },
  components: {
    DropZone,
    RelationSwiperTool,
  },
  watch: {
    showfiles: {
      handler(newVal) {
        this.$emit("update:files", newVal);
      },
      deep: true,
      immediate: true,
    },
    files: {
      handler(newVal) {
        this.showfiles = newVal;
      },
      deep: true,
    },
  },
  methods: {
    checkFile(file) {
      let name = /^device\//.test(file.name)
        ? file.name.substring(44)
        : file.name;
      let suffix = name.substring(name.lastIndexOf("."));
      let type = /\.(png|jpeg|jpg)$/.test(suffix)
        ? "image"
        : /\.(ppt|pptx|pdf|xls|xlsx|doc|docx)$/.test(suffix)
          ? "document"
          : "video";
      let i = this.showfiles[type].findIndex((item) => {
        let object_name = /^device\//.test(item.object_name)
          ? item.object_name.substring(44)
          : item.object_name;
        return object_name === name;
      });
      return i == -1;
    },
    async selectedFile() {
      let dropzoneFile = document.querySelector(".dropzoneFile").files[0];
      if (!dropzoneFile) return;

      if (dropzoneFile.size > this.fileMaxSize) {
        this.$emit(
          "handleAlert",
          "danger",
          this.$t("page.files_upload.file_size_cannot_exceed_50M"),
          "ri-error-warning-line"
        );
        document.getElementById("dropzoneFile").value = "";
        return;
      }

      if (!this.checkFile(dropzoneFile)) {
        this.$emit(
          "handleAlert",
          "danger",
          this.$t("page.files_upload.same_name_file"),
          "ri-error-warning-line"
        );
        document.getElementById("dropzoneFile").value = "";
        return;
      }
      let suffix = dropzoneFile.name.substring(
        dropzoneFile.name.lastIndexOf(".")
      );
      if (/\.(png|jpeg|jpg)$/.test(suffix)) {
        let file = await imageCompress(dropzoneFile);
        this.uploadFileSign(file);
      } else {
        this.uploadFileSign(dropzoneFile);
      }
    },
    async drop(e) {
      let dropzoneFile = e.dataTransfer.files[0];
      if (!dropzoneFile) return;

      if (dropzoneFile.size > this.fileMaxSize) {
        this.$emit(
          "handleAlert",
          "danger",
          this.$t("page.files_upload.file_size_cannot_exceed_50M"),
          "ri-error-warning-line"
        );
        document.getElementById("dropzoneFile").value = "";
        return;
      }

      if (!this.checkFile(dropzoneFile)) {
        this.$emit(
          "handleAlert",
          "danger",
          this.$t("page.files_upload.same_name_file"),
          "ri-error-warning-line"
        );
        document.getElementById("dropzoneFile").value = "";
        return;
      }
      let suffix = dropzoneFile.name.substring(
        dropzoneFile.name.lastIndexOf(".")
      );
      if (/\.(png|jpeg|jpg)$/.test(suffix)) {
        let file = await imageCompress(dropzoneFile);
        this.uploadFileSign(file);
      } else {
        this.uploadFileSign(dropzoneFile);
      }
    },
    /* 删除文件 */
    deleteFile(i, type) {
      Swal.fire(this.$t("base.delete_success"));
      this.showfiles[type].splice(i, 1);
    },
    uploadFileSign(file) {
      Swal.fire({
        title: this.$t("page.files_upload.uploading"),
        showConfirmButton: false,
      });
      Swal.showLoading();
      let filename = file.name;
      let objectName = `device/${uuidv4()}/${filename}`;
      let params = {
        object: objectName,
        method: "upload",
      };
      getUploadFileSign(params)
        .then((res) => {
          if (res && res.payload) {
            axios
              .put(res.payload.signedUrl, file, {
                headers: { "Content-Type": file.type },
              })
              .then(() => {
                let params = {
                  object: objectName,
                };
                getUploadFileDetail(params).then((resDetail) => {
                  if (resDetail && resDetail.payload) {
                    let detail = resDetail.payload;
                    let info = {
                      url: detail.url,
                      etag: detail.etag,
                      size: detail.size,
                      content_type: detail.contentType,
                      object_name: detail.objectName,
                      last_modified: detail.lastModified,
                      relation_type: 'self', //非继承文件
                    };
                    let suffix = info.object_name.substring(
                      info.object_name.lastIndexOf(".")
                    );
                    if (/\.(png|jpeg|jpg)$/.test(suffix)) {
                      this.showfiles["image"].push(info);
                    } else if (
                      /\.(ppt|pptx|pdf|xls|xlsx|doc|docx)$/.test(suffix)
                    ) {
                      this.showfiles["document"].push(info);
                    } else if (/\.(stp|glb)$/.test(suffix)) {
                      if (!this.showfiles["3d"]) {
                        this.showfiles["3d"] = [];
                        this.showfiles["3d"].push(info);
                      } else {
                        this.showfiles["3d"].push(info);
                      }
                    } else {
                      this.showfiles["video"].push(info);
                    }
                    console.log(this.showfiles);
                    document.getElementById("dropzoneFile").value = "";
                    Swal.close();
                    this.$emit(
                      "handleAlert",
                      "success",
                      this.$t("base.upload_success"),
                      "ri-check-double-line"
                    );
                  }
                });
              })
              .catch(() => {
                Swal.close();
                this.$emit(
                  "handleAlert",
                  "danger",
                  this.$t("base.delete_failed_please_try_again"),
                  "ri-error-warning-line"
                );
                document.getElementById("dropzoneFile").value = "";
              });
          }
        })
        .catch(() => {
          Swal.close();
          this.$emit(
            "handleAlert",
            "danger",
            this.$t("base.delete_failed_please_try_again"),
            "ri-error-warning-line"
          );
          document.getElementById("dropzoneFile").value = "";
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.material-title {
  border-left: 3px solid;
  padding-left: 8px;
  height: 22px;
  line-height: 22px;
}
</style>
